import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleAd } from '@fortawesome/free-solid-svg-icons';

const BannerIcon = ({ size = 22, color = 'currentColor', className, onClick }) => (
  <FontAwesomeIcon
    icon={faRectangleAd}
    className={className}
    onClick={onClick}
    style={{ fontSize: size, color, width: '1em', height: '1em', cursor: onClick ? 'pointer' : undefined }}
  />
);

export default BannerIcon;
